import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { NavParams, ModalController } from '@ionic/angular';
import { DataService, AppService } from 'src/app/service';
import { TranslateService } from '@ngx-translate/core';
import * as dd from 'dingtalk-jsapi'; // 引入钉钉jsapi

@Component({
  selector: 'app-org-cascader',
  templateUrl: './org-cascader.component.html',
  styleUrls: ['./org-cascader.component.scss'],
})
export class OrgCascaderComponent implements OnInit {
  returnSpaceTree = false; // 是否把spaceTree结构也返回
	pageTitle = '';
	placeholderMessage = '';
  search: string; // 搜索文本
	originalOptionList = []; // 原始结构数据
	searchList = []; // 筛选使用数据
  optionList = []; // 树形结构数据
	selected: any; // 选择的数据

	isLoading = false;
  optionCrumbs = []; // 组织架构面包屑
  instantClose;
	searchData = []; // 其他查询条件
  businessScope = null;
  filterParentOrg = null;
  constructor(
    private navParams: NavParams,
    private modalController: ModalController,
    private appService: AppService,
    private dataService: DataService,
    public cd: ChangeDetectorRef,
    private translateService: TranslateService,
  ) { 
    let params = this.navParams.data;
		this.pageTitle = params.pageTitle ? params.pageTitle : 'shared_components.common.project_name';
		this.placeholderMessage = params.placeholderMessage ? params.placeholderMessage : this.translateService.instant('shared_components.common.project_name');
    this.selected = params.selected ? params.selected : null;
    this.returnSpaceTree = params.returnSpaceTree ? params.returnSpaceTree : false;
		this.searchData = params.searchData ? params.searchData : [];
    this.filterParentOrg = params.filterParentOrg ? params.filterParentOrg : null;
    this.businessScope = params.businessScope ? params.businessScope : null;
  }

  async ngOnInit() {
    // Ionic modal 的 componentProps 是在构造函数之后通过 Object.assign 直接赋值到实例属性上的，
    // 此时才是 pageTitle 的最终原始值（翻译 key），因此翻译必须放在这里而不是构造函数里。
    this.pageTitle = this.translateService.instant(this.pageTitle);
    // 设置标题
		document.getElementsByTagName('title').item(0).innerText = this.pageTitle;
		if (dd.env.platform !== 'notInDingTalk') {
			dd.biz.navigation.setTitle({
				title: this.pageTitle // 钉钉设置导航栏标题
			});
		}

    // 获取组织架构数据
    await this.getCascadeList();
		this.optionList = this.originalOptionList;
    this.searchList = JSON.parse(JSON.stringify(this.optionList));
    this.initPageData();
    this.cd.detectChanges();

    const that = this;
    window.onpopstate = function () {
      const a = document.getElementsByTagName('app-org-cascader');
      if (a.length > 0) {
        setTimeout(() => {
          that.modalController.dismiss();
        }, 100)
      }
    };
  }

  async getCascadeList(): Promise<any> {
		const param = {
			pagingTool: {
        currentPage: 1,
        pageSize: -1
			},
			queryCriterias: this.searchData,
      params:{}
		};
    if (this.filterParentOrg) { // 筛选子组织架构
      param.params['filterParentOrg'] = this.filterParentOrg
    }
    const promise = new Promise<void>((resolve, reject) => {
		  this.isLoading = true;
			this.dataService.getCascadeTreeData(param, this.businessScope ? this.businessScope : '').subscribe(res => {
		    this.isLoading = false;
				if (res && res.STATUS === 0) {
          this.originalOptionList = res.DATA;
					resolve();
				} else {
					this.appService.toastTip(res.MSG, false);
					reject();
				}
			});
		});
		return promise;
	}

  // 编辑进入：配置初始面包屑导航和数据
  initPageData() {
    if (this.optionList.length > 0 && this.selected) {
      // 配置面包屑
      this.setCrumbs(this.optionList, this.selected.id);
      // 追加面包屑默认目录
      this.optionCrumbs.unshift({
        value: {
          full_name: this.pageTitle,
        },
        list: this.searchList,
      })
      // 回填默认下拉
      if (this.optionCrumbs.length > 1) {
        const lastData = this.optionCrumbs[this.optionCrumbs.length - 1];
        this.optionList = lastData.list;
        this.searchList = JSON.parse(JSON.stringify(this.optionList));
      }
    } else {
      // 默认配置-根目录
      this.optionCrumbs = [{
        value: {
          full_name: this.pageTitle,
        },
        list: this.searchList,
      }]
    }
  }

  // 递归获取选中的数据
  setCrumbs(arr, nodeId) {
    if (!arr || arr.length === 0) { // 判断数据是否存在并且不为空，如果是，则直接返回空数组
      return [];
    }
    const filteredData = []; // 定义过滤后的数据数组
    for (let i = 0; i < arr.length; i++) { // 遍历每个节点
      const node = arr[i];
      if (node.id == nodeId) {
        filteredData.push(node.id);
      }
      if (node.childCorporates && node.childCorporates.length > 0) { // 如果当前节点存在子节点，则递归遍历子节点
        const filteredChildCorporates = this.setCrumbs(node.childCorporates, nodeId); // 对子节点进行递归过滤
        if (filteredChildCorporates.length > 0) { // 如果过滤后的子节点不为空，则将该节点加入到过滤后的数据数组中，并将过滤后的子节点作为其 children 属性的值
          filteredData.push({
            id: node.id,
            children: filteredChildCorporates,
          });
          // 构造面包屑导航
          if (node.id !== nodeId) {
            this.optionCrumbs.unshift({
              value: node,
              list: node.childCorporates,
            })
          }
        }
      }
    }
    return filteredData;
  }

  // 点击选择地点
  clickOption(value) {
    this.selected = value;
  }

  // 下一级
  nextLevel(value) {
    this.optionCrumbs.push({
      value: value, // 当前选择数据
      list: JSON.parse(JSON.stringify(value.childCorporates)) // 保存数据结构，返回上级时使用
    });
    this.optionList = value.childCorporates;
    this.search = '';
    this.searchList = JSON.parse(JSON.stringify(this.optionList));
  }

  // 点击组织架构面包屑
  clickOptionCrumbs(item, index) {
    if (index === this.optionCrumbs.length - 1 || this.optionCrumbs.length === 0) {
      return;
    } else {
      // 找到选中元素的下拉层级
      this.optionList = item.list;
      this.search = '';
      this.searchList = JSON.parse(JSON.stringify(this.optionList));
      // 删除到此的面包屑
      this.optionCrumbs = this.optionCrumbs.splice(0, index + 1);
    }
  }

  // 搜索组织架构
  searchOrg() {
    if (this.search && this.optionList.length > 0) {
      this.optionList = this.optionList.filter(item => {
        // 不区分大小写
        const fullName = item.full_name.toUpperCase();
        const search = this.search.toUpperCase();
        return fullName.indexOf(search) !== -1;
      })
    } else {
      this.optionList = this.searchList;
    }
  }

  // 确认
  async confirm() {
    const confimData = JSON.parse(JSON.stringify(this.selected));
    delete confimData.childCorporates;
    if (this.returnSpaceTree) {
      const tempArr = [];
      this.optionCrumbs.forEach((item, index) => {
        if (index !== 0) {
          tempArr.push(item.value.id);
        }
      });
      tempArr.push(confimData.id);
      await this.modalController.dismiss({
        orgDTO: confimData,
        orgTree: tempArr,
      });
    } else {
      await this.modalController.dismiss(confimData);
    }
    history.back();
  }

  async cancel() {
    await this.modalController.dismiss();
    history.back();
  }
}
